import { render } from "./Admin.vue?vue&type=template&id=06c9d7da"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=06c9d7da&lang=scss"

import exportComponent from "/codebuild/output/src703991735/src/Jessy-Rent-O-/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__